import * as React from 'react';

import { RouteStore } from 'bernie-core';

import { RoomViewModel } from 'models';

import { classNames } from 'uitk-react-utils';
import { UitkCard, UitkCardImageLayout } from 'uitk-react-cards';

import { OffersListingPlaceholderLarge } from 'components/infosite/rooms-and-rates/loading-placeholder';
import { RatePlanControlView } from './rate-plan-control-view';
import { RatePlanGridView } from './rate-plan-grid-view';
import { RoomInfoCrawlable } from 'components/infosite/rooms-and-rates/room-info-crawlable';
import { RoomProps } from './room';

export const LargeView: React.FC<RoomProps> = ({ classList, loading, room, position, routeStore, isDateless, currentHotel }) => {
  const { roomSummary, name, photos } = room;

  if (loading) {
    return <OffersListingPlaceholderLarge />;
  }

  const roomNameClass = classNames('room_name', 'room__more-details', { 'all-b-padding-two': !roomSummary });
  const roomDetailsWrapperClass = classNames(
    'uitk-cell all-y-padding-three',
    {
      'all-cell-1-3': !isDateless,
    },
    {
      'all-cell-2-3': isDateless,
    }
  );

  const hasPhotos = photos && photos.length > 0;

  const rateplanDefaultProps = {
    isDateless,
    hasPhotos,
    room,
    position,
    roomNameClass,
    name,
  };

  return (
    <li className={`uitk-cell room ${classList?.join(' ')}`} data-stid="section-roomtype">
      <h3 className="is-visually-hidden">{name}</h3>
      <UitkCard className="room__card" imageLayout={UitkCardImageLayout.LEFT_FULLBLEED}>
        <LargeViewContent
          rateplanDefaultProps={rateplanDefaultProps}
          displayMultipleRatePlansInline={currentHotel?.canDisplayMultipleRatePlansInline}
          roomDetailsWrapperClass={roomDetailsWrapperClass}
          routeStore={routeStore}
        />
      </UitkCard>
      {isDateless && <RoomInfoCrawlable room={room} />}
    </li>
  );
};

export interface LargeViewContentProps {
  roomDetailsWrapperClass?: string;
  routeStore?: RouteStore;
  displayMultipleRatePlansInline?: boolean;
  rateplanDefaultProps: {
    isDateless?: boolean;
    hasPhotos?: boolean;
    room: RoomViewModel;
    position?: string;
    roomNameClass?: string;
    name?: any;
  };
}

export const LargeViewContent: React.FC<LargeViewContentProps> = ({
  rateplanDefaultProps,
  displayMultipleRatePlansInline,
  roomDetailsWrapperClass,
  routeStore,
}: LargeViewContentProps) => {
  if (displayMultipleRatePlansInline) {
    return <RatePlanGridView {...rateplanDefaultProps} hideRoomTitleToA11y={true} />;
  }

  return (
    <RatePlanControlView
      {...rateplanDefaultProps}
      roomDetailsWrapperClass={roomDetailsWrapperClass}
      routeStore={routeStore}
      hideRoomTitleToA11y={true}
    />
  );
};
